import React, { useState } from "react";
import API from "../../api/axiosConfig";
import { toast } from "react-toastify";

export default function ResetPasswordModal({ user, onClose }) {
  const [loading, setLoading] = useState(false);
  const [newPass, setNewPass] = useState("");

  const reset = async () => {
    setLoading(true);
    try {
      const res = await API.post(`/users/${user.id}/reset-password`);
      setNewPass(res.data.newPassword);
      toast.success("Contraseña reseteada");
    } catch {
      toast.error("Error reseteando contraseña");
    }
    setLoading(false);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(newPass);
    toast.success("Contraseña copiada");
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Resetear contraseña</h2>

        {!newPass ? (
          <button
            onClick={reset}
            disabled={loading}
            className="w-full px-4 py-2 bg-red-500 text-white rounded-lg"
          >
            {loading ? "Procesando..." : "Generar nueva contraseña"}
          </button>
        ) : (
          <div className="space-y-3">
            <div>
              <p className="text-gray-700 mb-2">Nueva contraseña:</p>
              <p className="text-lg font-bold bg-gray-100 p-2 rounded select-all">
                {newPass}
              </p>
            </div>

            <button
              onClick={copyToClipboard}
              className="w-full px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg"
            >
              Copiar contraseña
            </button>
          </div>
        )}

        <button
          onClick={onClose}
          className="mt-4 w-full px-4 py-2 bg-gray-300 rounded-lg"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}
